//
import React, { Component } from 'react'
import { connect } from 'react-redux'

const Ad = ({ ad }) =>
    ad ? <div dangerouslySetInnerHTML={{ __html: ad.code }} /> : null

export default connect(({ app: { integrations: { ad } = {} } }) => ({ ad }))(Ad)
